import { render, staticRenderFns } from "./ChatItemLoteFornecedor.vue?vue&type=template&id=3b6634cc&scoped=true"
import script from "./ChatItemLoteFornecedor.vue?vue&type=script&lang=js"
export * from "./ChatItemLoteFornecedor.vue?vue&type=script&lang=js"
import style0 from "./ChatItemLoteFornecedor.vue?vue&type=style&index=0&id=3b6634cc&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6634cc",
  null
  
)

export default component.exports